import React from 'react';
import { Resource } from './Resource';
import { Extractor } from './Extractor';
import { EnergyGenerator } from './EnergyGenerator';

class TerrainBlock extends React.Component {
  checkResourceAvailability = () => {
    return this.props.data.totalResources <= 0;
  };

  onDrop = (event) => {
    event.preventDefault();
    console.log('onDrop', this);
    this.props.data.type = 'generator';
    const { prevProps } = this.props;
    let data = JSON.parse(event.dataTransfer.getData('text/plain'));
    console.log(data, this);
    switch (data.data.properties.type) {
      case 'energy':
        if (
          data.data.properties.amountPlaced !==
          prevProps.inventory[data.name].properties.amountPlaced
        ) {
          console.log('not equal');
          this.setState(data, () => {
            this.props.callback(this.props.prevProps);
          });
        } else {
          console.log('equal');
          this.setState(data, () => {
            prevProps.energy =
              prevProps.energy + this.state.data.properties.generation;
            ++prevProps.inventory[this.state.name].properties.amountPlaced;
            --prevProps.inventory[this.state.name].value;
            this.props.callback(this.props.prevProps);
          });
        }
        break;

      default:
        console.log('should not happen');
        break;
    }
  };

  onDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    console.log('ondragover terrainblock');
  };

  render() {
    const { data } = this.props;
    let string =
      data.tile === 'resource'
        ? 'resource'
        : data.type === 'generator'
        ? 199
        : data.tile;
    let style;
    if (typeof string === 'object') {
      style = {
        backgroundImage:
          "url('/tiles/tileset_" +
          string[0] +
          ".png'), url('/tiles/tileset_" +
          string[1] +
          ".png')",
      };
    } else {
      style = {
        backgroundImage: "url('/tiles/tileset_" + string + ".png')",
      };
    }

    //console.log(data);

    /*return (
            <React.Fragment>
                { data.type === "resource" ? <ResourceTile x={data.x * this.props.width} y={data.y * this.props.height} width={this.props.width} height={this.props.height} data={data}/>  :
                    <Tile x={data.x * this.props.width} y={data.y * this.props.height} width={this.props.width} height={this.props.height} data={data}/> }
            </React.Fragment>

        )*/
    return (
      <div
        className={'terrain__block terrain__block__' + data.type}
        style={style}
      >
        {data.type === 'resource' ? (
          <React.Fragment>
            {data.extracting ? (
              <Extractor
                callback={this.callback}
                data={data}
                state={this.state}
                prevProps={this.props.prevProps}
              />
            ) : (
              <Resource
                data={data}
                callback={this.callback}
                drill={this.props.prevProps.drill}
                empty={this.checkResourceAvailability()}
                prevProps={this.props.prevProps}
                redux={this.props.redux}
              />
            )}
          </React.Fragment>
        ) : data.type === 'generator' ? (
          <EnergyGenerator
            data={this.state.data}
            name={this.state.name}
            props={data}
          />
        ) : (
          <div
            className="terrain__block-empty"
            onDrop={this.onDrop}
            onDragOver={this.onDragOver}
          >
            {}
          </div>
        )}
      </div>
    );
  }
}

function Tile(props) {
  if (Array.isArray(props.data.tile)) {
    return (
      <p>1</p>
      // <Container>
      //   <Sprite
      //     texture={PIXI.Texture.from(
      //       '/tiles/tileset_' + props.data.tile[1] + '.png'
      //     )}
      //     {...props}
      //     interactive={false}
      //     pointerdown={() => {
      //       console.log(props);
      //     }}
      //   />
      //   <Sprite
      //     texture={PIXI.Texture.from(
      //       '/tiles/tileset_' + props.data.tile[0] + '.png'
      //     )}
      //     {...props}
      //     interactive={false}
      //     pointerdown={() => {
      //       console.log(props);
      //     }}
      //   />
      // </Container>
    );
  } else {
    return (
      <p>2</p>
      // <Sprite
      //   texture={PIXI.Texture.from(
      //     '/tiles/tileset_' + props.data.tile + '.png'
      //   )}
      //   {...props}
      //   interactive={true}
      //   pointerdown={() => {
      //     console.log(props);
      //   }}
      // />
    );
  }
}

function ResourceTile(props) {
  if (Array.isArray(props.data.tile)) {
    return (
      <p>R</p>
      // <Container>
      //   <Sprite
      //     texture={PIXI.Texture.from(
      //       '/tiles/tileset_' + props.data.tile[1] + '.png'
      //     )}
      //     {...props}
      //     interactive={false}
      //     pointerdown={() => {
      //       console.log(props);
      //     }}
      //   />
      //   <Sprite
      //     texture={PIXI.Texture.from(
      //       '/tiles/tileset_' + props.data.tile[0] + '.png'
      //     )}
      //     {...props}
      //     interactive={false}
      //     pointerdown={() => {
      //       console.log(props);
      //     }}
      //   />
      //   <Sprite
      //     texture={PIXI.Texture.from('/tiles/resource.png')}
      //     {...props}
      //     interactive={false}
      //     pointerdown={() => {
      //       console.log(props);
      //     }}
      //   />
      // </Container>
    );
  } else {
    return (
      <p>3</p>
      // <Container>
      //   <Sprite
      //     texture={PIXI.Texture.from(
      //       '/tiles/tileset_' + props.data.tile + '.png'
      //     )}
      //     {...props}
      //     interactive={true}
      //     pointerdown={() => {
      //       console.log(props);
      //     }}
      //   />
      //   <Sprite
      //     texture={PIXI.Texture.from('/tiles/resource.png')}
      //     {...props}
      //     interactive={false}
      //     pointerdown={() => {
      //       console.log(props);
      //     }}
      //   />
      // </Container>
    );
  }
}

export { TerrainBlock, Tile, ResourceTile };
